import api from './api';

export const customProductsService = {
    // Get all My Products (Admin: support filtering; Reseller: own)
    getAll: async (params = {}) => {
        const response = await api.get('/custom-products', { params });
        return response.data;
    },

    // Create custom product
    create: async (data) => {
        const response = await api.post('/custom-products', data);
        return response.data;
    },

    // Update custom product
    update: async (id, data) => {
        const response = await api.put(`/custom-products/${id}`, data);
        return response.data;
    },

    // Delete custom product
    delete: async (id) => {
        const response = await api.delete(`/custom-products/${id}`);
        return response.data;
    }
};

export default customProductsService;
